import { DefaultState } from 'store/types';

export const LOCATION_MATCHES_ROOMS_REQUEST = 'LOCATION_MATCHES_ROOMS_REQUEST';
export const LOCATION_MATCHES_ROOMS_SUCCESS = 'LOCATION_MATCHES_ROOMS_SUCCESS';
export const LOCATION_MATCHES_ROOMS_FAILURE = 'LOCATION_MATCHES_ROOMS_FAILURE';

export interface LocationMatchesRoomsParams {
  lodgingOptionId: string;
  lodgingRequestId: string;
};

export interface LocationMatchesRoomsDataRow {
  bookedCount: number;
  compatibility: number;
  fromDate: string;
  toDate: string;
  id: string;
  isFull: boolean;
  occupancy: number;
  pricePerDayPerBed: number;
  type: string;
};

export type LocationMatchesRoomsData = LocationMatchesRoomsDataRow[];

export type LocationMatchesRoomsState = DefaultState & {
  contents?: LocationMatchesRoomsData;
};

interface LocationMatchesRoomsRequest {
  type: typeof LOCATION_MATCHES_ROOMS_REQUEST;
};

interface LocationMatchesRoomsSuccess {
  type: typeof LOCATION_MATCHES_ROOMS_SUCCESS,
  contents: LocationMatchesRoomsData;
}

interface LocationMatchesRoomsFailure {
  type: typeof LOCATION_MATCHES_ROOMS_FAILURE;
}

export type LocationMatchesRoomsActionTypes = LocationMatchesRoomsRequest | LocationMatchesRoomsSuccess | LocationMatchesRoomsFailure;